import { Card } from "react-bootstrap";

const EmptyChat = () => {
  return (
    <Card>
      <div className="text-center lao">
        <h3 className="mt-4">ເລືອກສົນທະນາ</h3>
      </div>
    </Card>
  );
};

export default EmptyChat;
